export default __webpack_public_path__ + "assets/product-overview-video-2-thumbnail-new.png";